module.exports = __webpack_public_path__ + "img/toomiro.768284d8.png";